export const pt = (options?: {ariaLabel?: string}) => ({
  pcListbox: { list: { 'aria-label': options?.ariaLabel } }
});